// extracted by mini-css-extract-plugin
export var buttonContent = "_37-0";
export var centered = "_37-1";
export var centeredFlex = "_37-2";
export var errorText = "_37-3";
export var icon = "_37-4";
export var iconButtonContent = "_37-5";
export var monospace = "_37-6";
export var padded = "_37-7";